export default __webpack_public_path__ + "static/media/single-project-page-01-img1.da789268.jpg";